import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import { ReactNode, SyntheticEvent, useState } from "react";

interface ProductContentSectionProps {
  title: string;
  children: ReactNode;
}

const ProductContentSection = ({
  title,
  children,
}: ProductContentSectionProps) => {
  const [isOpen, setIsOpen] = useState(true);

  const handleChange = (_event: SyntheticEvent, expandValue: boolean) => {
    setIsOpen(expandValue);
  };

  return (
    <Accordion defaultExpanded onChange={handleChange}>
      <AccordionSummary
        expandIcon={
          isOpen ? (
            <RemoveIcon fontSize="large" />
          ) : (
            <AddIcon fontSize="large" />
          )
        }
      >
        <Typography variant="h3">{title}</Typography>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
};
export default ProductContentSection;
